export default __webpack_public_path__ + "static/media/580.658485bd.gif";